import 'core-js/stable';

// eslint-disable-next-line import/extensions
require('@webcomponents/webcomponentsjs/webcomponents-bundle.js');
require('../bootStimulus');

require('../stylesheets/booking_system.scss');
require('../stylesheets/custom.scss');

require.context('../images', true);
